import * as actions from "./actionTypes";

export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag
  }
});

export const screenLoadingAction = (isLoading) => ({
  type: actions.SCREEN_LOADING,
  payload: {
    description: isLoading
  }
});

export const clearAllAction = () => ({
  type: actions.CLEAR_ALL
});

export const setAppProperty = (key, value) => ({
  type: actions.SET_APP_PROPERTY,
  payload: {
    key,
    value
  }
});

export const setQuestionAnswer = (questionNumber, questionAnswer, flag) => ({
  type: actions.SET_QUESTION_ANSWER,
  payload: {
    questionNumber,
    questionAnswer,
    flag
  }
});

export const setQuestionAnswerFrench = (
  questionNumber,
  questionAnswerFrench
) => ({
  type: actions.SET_QUESTION_ANSWER,
  payload: {
    questionNumber,
    questionAnswerFrench
  }
});

export const changeObjectPropertyAction = (object, field, value) => ({
  type: actions.CHANGE_OBJECT_PROPERTY,
  payload: {
    object,
    field,
    value
  }
});

export const addNewAdultAction = () => ({
  type: actions.ADD_NEW_ADULT
});

export const removeAdultAction = (localId) => ({
  type: actions.REMOVE_OTHER_ADULT,
  payload: localId
});

export const updateOtherAdultAction = (otherAdult) => ({
  type: actions.UPDATE_OTHER_ADULT,
  payload: otherAdult
});

export const setOtherAdultAssessmentFiles = (otherAdultFiles) => ({
  type: actions.SET_OTHER_ADULT_FILES,
  payload: otherAdultFiles
});

export const removeFiles = (field,value) => ({
  type: actions.REMOVE_FILES,
  payload: {field,value}
});
